import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Hash } from 'lucide-react';
import { NoData } from './ui/noData';

interface HashtagCloudProps {
  platform: string;
  hashTagData?:any;
}

const hashtags = [
  { tag: '#brandname', uses: 582, er: 9.2 },
  { tag: '#campaign2024', uses: 456, er: 8.8 },
  { tag: '#newlaunch', uses: 389, er: 10.1 },
  { tag: '#trending', uses: 312, er: 7.5 },
  { tag: '#lifestyle', uses: 298, er: 8.3 },
  { tag: '#fashion', uses: 276, er: 9.0 },
  { tag: '#beauty', uses: 245, er: 8.7 },
  { tag: '#tech', uses: 198, er: 7.9 }
];

// const maxUses = Math.max(...hashtags.map(h => h.uses));


export function HashtagCloud({ platform, hashTagData }: HashtagCloudProps) {

  const maxUses = hashTagData?.length
  ? Math.max(...hashTagData.map((h: any) => h.hashtag_count))
  : 1;

  const allHashtags = hashTagData ?? [];

    const filteredHashtags = allHashtags.filter(
      (h: any) => h.hashtag_count >= 10
    );

    // hashtags with less than 10
    const lessThanTen = allHashtags.filter(
      (h: any) => h.hashtag_count < 10
    );
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Hash className="h-5 w-5 text-blue-600" />
          <CardTitle>Top Performing Hashtags</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 position-relative" style={{zIndex:0}}>
         {(hashTagData?.length > 0 ? hashTagData : []).length > 0 &&
          allHashtags?.map((hashtag: any, index: any) => (
            <div key={index} data-pdf-row className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-blue-700 text-xs">
                    {index + 1}
                  </span>
                  <span className="text-slate-900" style={{ fontSize: "14px" }}>
                    {hashtag.tag}
                  </span>
                </div>

                {/* uses count hidden - not needed on Top Performing Hashtags */}
                {/* <div className="flex items-center gap-4">
                  <span className="text-sm text-slate-600">{hashtag.hashtag_count} uses</span>
                </div> */}
              </div>

              <div className="w-full h-2 bg-slate-200/60 rounded-full overflow-hidden mt-2">
                <div className="bar-container">
                  <div
                    className="bar-fill"
                    style={{ width: `${(hashtag.hashtag_count / maxUses) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
  
          {(allHashtags.length === 0) && (
          <NoData message="No hashtag data available for the selected range." />
        )}
        
{/* {allHashtags.length > 0 && filteredHashtags.length === 0 && (
  <NoData message="No hashtag data available for the selected range." />
)} */}
        </div>
      </CardContent>
    </Card>
  );
}
